<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{
        editar ? "Editar registro" : "Nuevo modificador"
      }}</span>
    </v-card-title>
    <v-card-text>
      <v-alert v-model="mostrar_alert" dismissible :type="type_alert">
        <template v-html="html_alert" />
      </v-alert>
      <v-container grid-list-md>
        <v-layout row>
          <v-flex xs12 sm6>
            <v-flex xs12>
              <v-text-field
                :value="form.nombre"
                :error-messages="error_input.nombre"
                label="Nombre"
                @input="(payload) => (form.nombre = payload)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :value="form.orden"
                :error-messages="error_input.orden"
                label="Orden"
                @input="(payload) => (form.orden = payload)"
              />
            </v-flex>
          </v-flex>
          <v-flex xs12 sm6>
            <v-flex xs12>
              <v-text-field
                :value="form.descripcion"
                :error-messages="error_input.descripcion"
                label="Descripción"
                @input="(payload) => (form.descripcion = payload)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :value="form.precio"
                :error-messages="error_input.precio"
                label="Precio"
                type="number"
                @input="(payload) => (form.precio = payload)"
              />
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="close"> Cancelar </v-btn>
      <v-btn
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="guardar"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import EventBus from "../EventBus";
export default {
  name: "FormModificadoresDetalles",
  props: {
    item: {
      type: [Array, Object],
      default: () => {
        return {
          id: 0,
          nombre: "",
          orden: null,
          precio: 0,
          modificador_id: this.modificadorId,
        };
      },
    },
    modificadorId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  data() {
    return {
      form: Object.assign(
        {
          id: 0,
          nombre: "",
          orden: null,
          precio: 0,
          modificador_id: this.modificadorId,
        },
        this.item
      ),
      error_input: {
        nombre: "",
        activo: "",
      },
      loading: false,
      mostrar_alert: false,
      type_alert: "success",
      html_alert: "",
    };
  },
  computed: {
    editar() {
      return this.item.id > 0;
    },
  },
  methods: {
    close() {
      this.form.id = 0;
      this.form.nombre = "";
      this.$emit("close", true);
    },
    guardar() {
      let url_target = this.editar
        ? "/api/modificador_detalle/actualizar/" + this.item.id
        : "/api/modificador_detalle/guardar";
      this.loading = true;
      this.error_input.nombre = "";
      axios
        .post(url_target, this.form)
        .then((success) => {
          let { data } = success;
          this.loading = false;

          if (data.success) {
            this.form.nombre = "";
            this.form.activo = false;
            EventBus.$emit("tugarrafon:show-snackbar", {
              color: "success",
              text_content: data.message,
            });
            this.$emit("save", data.data);
          }
        })
        .catch((error) => {
          this.loading = false;

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            if (error.response.status === 422) {
              this.error_input = Object.assign({}, error.response.data.data);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }
        });
    },
  },
};
</script>

<style>
</style>